var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "message-box dialog-mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickOutSide.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "dialog-box" }, [
        _c("div", { staticClass: "section dialog-header" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("timelinePage.createDialog.title")))]),
        ]),
        _c("div", { staticClass: "section dialog-body" }, [
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("h2", [
                _vm._v(
                  _vm._s(_vm.$t("timelinePage.createDialog.timelineName"))
                ),
              ]),
              _c("input-text", {
                attrs: { maxlength: 120 },
                model: {
                  value: _vm.timelineName,
                  callback: function ($$v) {
                    _vm.timelineName = $$v
                  },
                  expression: "timelineName",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "input-wrapper" }, [
            _c("h2", [
              _vm._v(_vm._s(_vm.$t("timelinePage.createDialog.headerFormat"))),
            ]),
            _c("div", { staticClass: "format-select" }, [
              _c(
                "div",
                {
                  staticClass: "radio-button",
                  class: { disabled: !_vm.canSelectChronology },
                  on: {
                    click: function ($event) {
                      _vm.canSelectChronology &&
                        _vm.onChangeTimelineType("chronology")
                    },
                  },
                },
                [
                  _c("radio-icon", {
                    attrs: {
                      value: "chronology",
                      selected: _vm.selectedTimelineType,
                      fill: _vm.checkBoxColor,
                    },
                  }),
                  _c(
                    "label",
                    { class: { disabled: !_vm.canSelectChronology } },
                    [_vm._v(_vm._s(_vm.$t("timelinePage.chronology")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "radio-button",
                  class: { disabled: !_vm.canSelectPlot },
                  on: {
                    click: function ($event) {
                      _vm.canSelectPlot && _vm.onChangeTimelineType("plot")
                    },
                  },
                },
                [
                  _c("radio-icon", {
                    attrs: {
                      value: "plot",
                      selected: _vm.selectedTimelineType,
                      fill: _vm.checkBoxColor,
                    },
                  }),
                  _c("label", { class: { disabled: !_vm.canSelectPlot } }, [
                    _vm._v(_vm._s(_vm.$t("timelinePage.plot"))),
                  ]),
                ],
                1
              ),
            ]),
            _vm.hasLimit
              ? _c("div", { staticClass: "caution" }, [
                  _vm._v(
                    _vm._s(_vm.$t("timelinePage.createDialog.limitMessage"))
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
        _c("div", { staticClass: "section button-area" }, [
          _c(
            "button",
            {
              staticClass: "button cancel",
              on: { click: _vm.onNegativeClick },
            },
            [_vm._v(_vm._s(_vm.negative || _vm.$t("common.cancel")))]
          ),
          _c(
            "button",
            {
              staticClass: "button primary",
              attrs: { disabled: !_vm.isCompleted },
              on: { click: _vm.onPositiveClick },
            },
            [_vm._v(_vm._s(_vm.positive || _vm.$t("common.create")))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }